module.exports = __webpack_public_path__ + "img/Estonia.144d6ee8.svg";